import OrganizationChart, { NodeChartTemplate } from "@dabeng/react-orgchart";
import { Alert } from "@mui/lab";
import { Dialog, DialogActions, DialogContent, Theme, Typography } from '@mui/material';
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Core";
import ButtonClose from "components/Buttons/ButtonClose";
import ButtonExport from "components/Buttons/ButtonExport";
import { SpinnerIndicator } from "components/CallServer";
import MuiDialogTitleClose from 'components/MuiExtras/MuiDialogTitleClose';
import { ManagerTreeNode } from 'models/ApiModels';
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const styles = (theme: Theme) => createStyles({
    dialogPaper: {
        minHeight: '80vh',
        maxHeight: '80vh',
    },

    "@global": {
        ".orgchart-container": {
            flexGrow: 1,
            height: "auto"
        },
        ".orgchart.myChart": {
            //backgroundImage: "linear-gradient(90deg,rgba(33, 90, 136, 0.15) 10%,rgba(0, 0, 0, 0) 10%), linear-gradient(rgba(33, 90, 136, 0.15) 10%, rgba(0, 0, 0, 0) 10%)!important",
            backgroundImage: "none"
        },

        ".orgchart.myChart > ul > li > ul li::before": {
            borderTopColor: "#215a88"
        },

        ".orgchart.myChart > ul > li > ul li .oc-node::before,.orgchart.myChart ul li .oc-node:not(:only-child)::after": {
            backgroundColor: "#215a88"
        },
        ".oc-node img": {
            width: 64,
            "-webkit-user-drag": "none",
            "-khtml-user-drag": "none",
            "-moz-user-drag": "none",
            "-o-user-drag": "none",
            "user-drag": "none"
        },
        ".oc-node .nodeContainer": {
            maxWidth: 200
        },
        ".oc-node .nodeName": {
            width: "calc(80%)",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "inline-block",
            overflow: "hidden"
        }
    }
});

export interface IState {
    loading: boolean;
    managerTreeNodes: ManagerTreeNode;
    selectedNode: string;
    dialog: any;
}

interface IProps {
    rootId?: string;
    rootName?: string;
    onClose: () => void;
}

type Props = IProps & WithStyles<typeof styles> & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const MyNode: NodeChartTemplate = ({ nodeData }) => {
    return (
        <div className="nodeContainer" title={nodeData.name}>
            <img src={nodeData.thumbnailUrl} alt="Thumbnail" />
            <div className="nodeName">
                <Typography component="span" variant="body1">{nodeData.name}</Typography>
            </div>
        </div>
    );
};

class UserDiagramDialog extends React.PureComponent<Props, IState> {
    private orgchart: any;

    constructor(props: Props) {
        super(props);
        this.state = {
            dialog: null,
            loading: true,
            managerTreeNodes: null,
            selectedNode: ""
        };
    }

    ///
    private loadData() {
        this.setState({ loading: true, managerTreeNodes: null });

        api.getManagerTree(this.props.rootId)
            .then((data) => {
                this.setState({ loading: false, managerTreeNodes: JSON.parse(data) });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    ///
    private export() {
        this.orgchart.exportTo("orgchart", "png");
    }

    ///
    public componentDidMount() {
        this.loadData();
    }

    ///
    public render() {
        const { loading, managerTreeNodes } = this.state;
        const style = managerTreeNodes != null ? { display: "flex" } : null;

        return (
            <Dialog
                open
                fullWidth
                onClose={() => { this.props.onClose(); }}
                maxWidth="lg"
                classes={{ paper: this.props.classes.dialogPaper }}
            >
                <MuiDialogTitleClose
                    title={this.props.t("Views.User.Dialogs.UserDiagramDialog.BoxTitle")}
                    subtitle={this.props.rootName}
                    onClose={() => { this.props.onClose(); }}
                />

                <DialogContent style={style}>
                    {
                        loading
                            ? <SpinnerIndicator />
                            : managerTreeNodes == null
                                ? <Alert severity="info">{this.props.t("Views.User.Dialogs.UserDiagramDialog.EmptyData")}</Alert>
                                : (
                                    <OrganizationChart
                                        datasource={managerTreeNodes}
                                        chartClass={"myChart"}
                                        NodeTemplate={MyNode}
                                        ref={(ref) => this.orgchart = ref}
                                        draggable={false}
                                        multipleSelect={false}
                                        zoom
                                        pan
                                        collapsible
                                    />
                                )
                    }
                </DialogContent>

                <DialogActions>
                    {
                        managerTreeNodes != null &&
                        <ButtonExport onClick={() => this.export()} color="info" />
                    }
                    <ButtonClose onClick={() => this.props.onClose()} color="default" />
                </DialogActions>
            </Dialog>
        );
    }
}

export default withTranslation()(withStyles(styles)(UserDiagramDialog));